<template>
<div class="user">
  <div class="questions">

    <div class="float-header">
      <h1>{{frm.title}} - <span class="gray">{{frm.exam_type_name}}</span></h1>
      <div>
      시험 공개일 <span class="number navy strong">{{formatterDate(frm.open_dt)}}</span>
      <a v-if="downloadFileUrl !== ''" class="paper-download" :href="downloadFileUrl" target="_blank">시험지 다운로드</a>
      <!-- / 시험 종료일 <span class="number navy strong">2018.06.14</span> -->
      </div>
      <p>
        총 문제 <span class="number navy strong">{{frm.quiz_cnt}}</span>
        풀이한 문제 <span class="number navy strong">{{solution_cnt}}</span>
        남은문제 <span class="number navy strong">{{remain_cnt}}</span>
      </p>
    </div>

    <div v-loading="searchLoading">
      <el-form :model="frm" status-icon ref="frm" label-width="0px" class="quiz-form">
        <el-form-item
          class="answer"
          v-for="(exam, index) in frm.exam_answer"
          :key="exam.quiz_seq"
          :prop="'exam_answer.' + index + '.exam_answer'"
          :rules="{ required: true, message: '답안을 체크하십시오.', trigger: 'change' }">
            <div class="quiz-no number strong">{{exam.display_no}}</div>
            <div class="question-group">
              <el-radio-group v-model="exam.exam_answer" v-for="item in exam.item_cnt" :key="item" @change="handlerAnswerClick(exam.quiz_seq, exam.exam_answer)">
                <el-radio-button :label="item + ''" :class="'btn-radio-circle' + (item === exam.exam_answer ? ' is-active' : '')">{{item}}</el-radio-button>
              </el-radio-group>
            </div>
            <!-- <el-radio v-model="exam.exam_answer" v-for="item in exam.item_cnt" :key="item" :label="item + ''" border>{{item}}</el-radio> -->
        </el-form-item>
      </el-form>
    </div>

    <div class="quiz-button">
      <!-- <button type="button" class="btn gray" @click="removeExamLocalStorage">로컬 초기화</button> -->
      <button v-if="activeMode === 'local' || activeMode === 'dev'" type="button" class="btn gray" @click="testAnswer">테스트</button>
      <button type="button" class="btn gray" @click="cancelExam">취소</button>
      <!-- <button type="button" class="btn gray" @click="resetForm('frm')">초기화</button> -->
      <button type="button" class="btn mint" @click="submitForm('frm')">제출</button>
    </div>

  </div>
</div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'S010102',
  mixins: [common.mixins],
  data () {
    return {
      frm: {
        exam_seq: 0,
        class_seq: 0,
        class_user_seq: 0,
        title: '',
        exam_paper_type: '',
        exam_type_name: '',
        exam_answer: [],
        open_dt: '',
        quiz_cnt: 0
      },
      solution_cnt: 0,
      answerMap: {},
      examInfo: {},
      activeMode: this.$store.getters.active_mode,
      messageClass: {customClass: 'user-quiz-message'},
      downloadFileUrl: ''
    }
  },
  computed: {
    remain_cnt: {
      get () {
        return this.frm.quiz_cnt - this.solution_cnt
      }
    }
  },
  created () {
    const examSeq = this.$route.params.exam_seq
    const classSeq = this.$route.params.class_seq
    if (!this.isEmptySeq(examSeq) && !this.isEmptySeq(classSeq)) {
      // this.loadInfo(examSeq, classSeq)
      // 시험 상태 확인
      this.checkedExamStat(examSeq, classSeq)
    }
  },
  methods: {
    checkedExamStat (examSeq, classSeq) {
      const params = Object.assign({class_user_seq: this.$store.getters.user_seq}, this.$route.params)
      common.axios.post('/exam/stat', params)
        .then(response => {
          const result = response.data
          if (result.message !== '') {
            this.$alert(result.message, '', {
              showClose: false,
              type: 'warning',
              center: true,
              callback: action => {
                this.removeExamLocalStorage()
                this.$nextTick(() => {
                  this.$router.push({name: 'S010101'})
                })
              }
            })
          } else {
            this.loadInfo(examSeq, classSeq)
          }
        })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('답안지를 제출하시겠습니까?', '', this.messageClass)
            .then(() => {
              common.axios.post('/exam/answer/storage', this.frm)
                .then(response => {
                  const result = response.data
                  // console.log(result)
                  if (result.status === 1) {
                    this.$message('제출하였습니다.')
                    this.removeExamLocalStorage()
                    this.$nextTick(() => {
                      setTimeout(() => {
                        this.$router.push({name: 'S010101'})
                      }, 1000)
                    })
                  } else {
                    // this.$message.error(result.message)
                    this.$alert(result.message, '', {
                      // confirmButtonText: 'OK',
                      showClose: false,
                      type: 'warning',
                      center: true,
                      callback: action => {
                        // -11001 : 시험이 종료되어 답안지를 제출할 수 없습니다.
                        // -11002 : 이미 답안지를 제출하였습니다.
                        // -11003 : 공개된 시험만 답안지를 제출할 수 있습니다.
                        // -11005 : 해당 시험 응시생이 아닙니다.
                        if (result.status < 0) {
                          this.removeExamLocalStorage()
                          // 해당 시험 응시생이 아닐 경우 강제로 로그아웃을 시킨다.
                          if (result.status === -11005) {
                            this.$store.dispatch('AUTH_LOGOUT').then(() => {
                              this.$router.push({name: 'LOGIN_S'})
                            })
                          } else {
                            this.$nextTick(() => {
                              this.$router.push({name: 'S010101'})
                            })
                          }
                        }
                      }
                    })
                  }
                })
                .catch(err => {
                  if (err.response.data.errors) {
                    err.response.data.errors.map(msg => {
                      this.$message.error(msg)
                    })
                  }
                })
            })
            .catch(() => {
            })
        } else {
          this.$message.error('답안 내용을 확인하십시오.')
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.frm.exam_answer.map(elem => { elem.exam_answer = '' })
      this.answerMap = {}
      this.solution_cnt = 0
    },
    cancelExam () {
      this.$confirm('진행중인 시험을 취소하고 목록으로 돌아가시겠습니까?', '', this.messageClass)
        .then(() => {
          this.$router.push({name: 'S010101'})
        })
        .catch(() => {
        })
    },
    loadInfo (examSeq, classSeq) {
      this.searchLoading = true
      common.axios.get('/exam/paper/' + examSeq)
        .then(response => {
          this.searchLoading = false
          const result = response.data
          // console.log('result : ', result)
          if (result.status < 0) {
            return
          }
          Object.keys(this.frm).forEach(key => {
            this.frm[key] = this.isEmpty(result.exam[key]) ? '' : result.exam[key]
          })
          this.frm.class_seq = classSeq
          this.frm.class_user_seq = this.$store.getters.user_seq
          this.frm.exam_answer = result.exam_answer

          this.downloadFileUrl = result.exam.paper_open_yn === 'Y' ? result.exam.download_url_pdf : ''

          this.examInfo.exam_seq = examSeq
          this.examInfo.class_seq = classSeq
          this.examInfo.user_seq = this.$store.getters.user_seq

          const tmpExam = this.$store.getters.tmp_exam
          // console.log('tmpExam : ', tmpExam)
          if (tmpExam[this.examInfo.user_seq] && tmpExam[this.examInfo.user_seq][classSeq] && tmpExam[this.examInfo.user_seq][classSeq][examSeq]) {
            this.$confirm('기존에 작성한 답안지 내용을 불러오시겠습니까?', '', this.messageClass)
              .then(() => {
                const tmpExamUserClassExam = tmpExam[this.examInfo.user_seq][classSeq][examSeq]
                Object.keys(tmpExamUserClassExam).forEach(key => {
                  this.frm.exam_answer.find(x => x.quiz_seq === parseInt(key, 10)).exam_answer = tmpExamUserClassExam[key]
                  this.answerMap[key] = tmpExamUserClassExam[key]
                })
                this.solution_cnt = Object.keys(this.answerMap).length
              })
              .catch(() => {})
          }
        })
        .catch(() => {
          this.searchLoading = false
        })
    },
    handlerAnswerClick (quizSeq, value) {
      this.answerMap[quizSeq] = value
      this.solution_cnt = Object.keys(this.answerMap).length
      this.registerExamLocalStorage()
    },
    testAnswer () {
      this.frm.exam_answer.map(x => {
        x.exam_answer = Math.floor(Math.random() * x.item_cnt) + 1
        this.answerMap[x.quiz_seq] = x.exam_answer
      })
      this.solution_cnt = Object.keys(this.answerMap).length
      this.registerExamLocalStorage()
    },
    registerExamLocalStorage () {
      this.examInfo.exam_answer = this.answerMap
      this.$store.dispatch('EXAM_TMP_REGISTER', this.examInfo)
        .catch(() => {
          console.error('EXAM_TMP_REGISTER Error')
        })
    },
    removeExamLocalStorage () {
      this.$store.dispatch('EXAM_TMP_DELETE', this.examInfo)
        .catch(() => {
          console.error('EXAM_TMP_DELETE Error')
        })
    }
  }
}
</script>

<style scoped>
  .paper-download {
    margin-left: 20px;
    color: crimson;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/S010102.vue